const filtersEnums = {
    FILTERS: 'Filters',
    RESET: 'Reset',
    APPLY: 'Apply',
};

export default filtersEnums;
